import styled, { css } from 'styled-components';
import Skeleton from 'react-loading-skeleton';

export const FormStyled = styled.form`
  width: 100%;
  height: calc(100vh - 260px);
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1 0 0px;
  background: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.05) 0px 2px 15px 0px;
  padding: 24px 0px;
  border-radius: 10px;
`;

export const RowStyled = styled.div`
  display: grid;
  grid-auto-columns: minmax(0, 1fr);
  grid-auto-flow: column;
  width: 100%;
  gap: 12px;
  padding: 0 24px;
  margin: 0 0 12px 0;

  @media screen and (max-width: 1280px) {
    grid-auto-flow: row;
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (max-width: 768px) {
    grid-auto-flow: row;
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const ColStyled = styled.div`
  display: block;
`;

export const ColStyledTwo = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: block;
  }
`;

export const LabelStyled = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.42px;
`;

export const ButtonStyled = styled.button`
  margin-top: 25px;
  border: none;
  border-radius: 8px;
  width: 100%;
  height: 36px;
  background-color: #5768ff !important;
  color: #fff !important;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.42px;
  line-height: 20px;
  cursor: pointer;

  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.02);
  }

  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.7;
      cursor: not-allowed;

      &:hover {
        transform: scale(1);
      }
    `}

  @media screen and (max-width: 768px) {
    margin-top: 10px;
  }
`;

export const ButtonStyledTwo = styled.button`
  height: 36px;
  background: transparent;
  border: 1px solid rgb(214, 214, 214) !important;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border-radius: 8px;
  color: #101010 !important;
  margin-top: 25px;
  margin-left: 10px;

  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    transform: scale(1.02);
  }

  @media screen and (max-width: 768px) {
    margin-top: 10px;
  }
`;

export const ButtonStyledThree = styled(ButtonStyledTwo)`
  width: 100%;
  height: 36px;
  margin: 0;
  &:hover {
    transform: scale(1);
  }
`;

export const BoxButtonsStyled = styled.div`
  gap: 10px;
  align-items: center;

  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;

  > * {
    flex-shrink: 0;
  }

  button {
    margin-top: 25px;
    cursor: pointer;
  }
`;

export const SkeletonField = styled(Skeleton)<{ marginTop?: string }>`
  margin-top: ${({ marginTop }) => marginTop || '0px'};
  margin-bottom: -24px;
  display: block;
`;
